module.exports = __webpack_public_path__ + "static/portfolio-sentoshi-e71dc27bba23c46f58750e107a5ed998.jpg";